import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";

// Assets
import five from "../../assets/images/dashboard/five.png";
import four from "../../assets/images/dashboard/four.png";
import doctor from "../../assets/images/dashboard/lady-doctor.png";
import one from "../../assets/images/dashboard/one.png";
import six from "../../assets/images/dashboard/six.png";
import three from "../../assets/images/dashboard/three.png";
import two from "../../assets/images/dashboard/two.png";

// Utils
import axiosInstance from "../../components/Utils/axiosInstance";

// Styles
import "./dashboard.scss";

// Helper for count-up animation
const useCountUp = (end, duration = 1) => {
  const [count, setCount] = useState(0);
  const startTimestamp = useRef(null);

  useEffect(() => {
    setCount(0);
    startTimestamp.current = null;
    if (typeof end !== "number" || isNaN(end)) return;

    const step = (timestamp) => {
      if (!startTimestamp.current) startTimestamp.current = timestamp;
      const progress = Math.min(
        (timestamp - startTimestamp.current) / (duration * 1000),
        1
      );
      setCount(Math.floor(progress * end));
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        setCount(end);
      }
    };
    requestAnimationFrame(step);
    // eslint-disable-next-line
  }, [end, duration]);

  return count;
};

// Card component for animation and count-up
const AnimatedCard = ({ el, inx, cardVariants }) => {
  const count = useCountUp(Number(el.count) || 0, 1.2);
  return (
    <motion.div
      style={{ background: el.bgColor }}
      custom={inx}
      initial="hidden"
      animate="visible"
      variants={cardVariants}
    >
      <div>
        <img src={el.image} alt="" />
      </div>
      <div>{el.text}</div>
      <div
        style={{
          color: el.countColor,
          fontWeight: 800,
          fontSize: 28,
        }}
      >
        {count}
      </div>
    </motion.div>
  );
};

const Dashboard = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("admin-panel/dashboard");
        setData(response.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchData();
  }, []);

  const overAllArr = [
    {
      image: one,
      text: "InstaDoc Registrations",
      count: data.instaDoc,
      bgColor: "#f3f3ff",
      countColor: "#030344",
    },
    {
      image: two,
      text: "Total Pharmacy Registrations",
      count: data.pharmacy,
      bgColor: "#eefcef",
      countColor: "#003904",
    },
    {
      image: three,
      text: "Total Doctor Registrations",
      count: data.doctor,
      bgColor: "#ffefe8",
      countColor: "#431400",
    },
    {
      image: four,
      text: "Total HHSP Registrations",
      count: data.healthCare,
      bgColor: "#e5f5fa",
      countColor: "#022D3A",
    },
    {
      image: five,
      text: "Total Other Registrations",
      count: data.other,
      bgColor: "#fff4e0",
      countColor: "#5A3A00",
    },
    {
      image: six,
      text: "Total Careers Registrations",
      count: data.career,
      bgColor: "#f3ecfe",
      countColor: "#1D004B",
    },
  ];

  const adLandingArr = [
    {
      image: doctor,
      text: "Total Doctor Registrations",
      count: data.doctorsAd,
      bgColor: "#f3f3ff",
      countColor: "#030344",
    },
  ];

  // Animation variants for cards
  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.1, type: "spring", stiffness: 60 },
    }),
  };

  return (
    <>
      <div className="home-dashboard">
        <div className="home-dashboard-box">
          <div className="home-dashboard-title fs22">Dashboard</div>
          <div className="home-dashboard-overall">Overall</div>
          <div className="home-dashboard-container">
            {overAllArr.map((el, inx) => (
              <AnimatedCard
                el={el}
                inx={inx}
                cardVariants={cardVariants}
                key={inx}
              />
            ))}
          </div>
          <div className="home-dashboard-overall">Ad Landing Forms</div>
          <div className="home-dashboard-container">
            {adLandingArr.map((el, inx) => (
              <AnimatedCard
                el={el}
                inx={inx}
                cardVariants={cardVariants}
                key={inx}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
